export const config = {
  shunno_pay_base_url: "https://shunnoit.top/shunno-payment/api/v1",
  shunno_pay_token:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJtanF1MWlnbCIsImlhdCI6MTc2Njk5MzA1NCwiZXhwIjo5MDA3MTk5MjU0NzQwOTkxLCJ0eXBlIjoiQVBJX0tFWSJ9.r-2LSj6H0DPtMmvJVaG-egZi7Z25dOHxbRDGmqPW7jk",
};
